import Service, { type Registry as Services, service } from '@ember/service';
import type AjaxService from 'lumen/services/ajax';
import { formatUrl } from 'lumen/utils/rates-request';

export default class SimpleExportService extends Service {
  @service declare ajax: AjaxService;
  @service declare errorTracking: Services['error-tracking'];

  /**
   * Executes a custom export in a separate window
   * @param context        : context for passing services
   * @param data        : stringified data for simple export POST
   * @param hotelOrMarketId        : the hotel or market ID
   * @param isSingleProperty   : single or multi property (params are based on this flag)
   */

  async execute(
    data: string,
    hotelOrMarketId: string,
    isSingleProperty = true,
  ): Promise<void> {
    const exportPath = '/apigateway/v1/app/download/custom';

    const params: Record<string, string> = {};
    if (isSingleProperty) {
      params['subscription_id'] = hotelOrMarketId;
    } else {
      params['market_id'] = hotelOrMarketId;
    }

    try {
      const response = await this.ajax.request<{ requestId: string }>(
        formatUrl(exportPath, params, this.ajax.host),
        {
          data,
          method: 'POST',
        },
      );

      params['requestId'] = response.requestId;
      const url = formatUrl(exportPath, params, this.ajax.host);
      window.location.href = url;
    } catch (error) {
      this.errorTracking.captureException(error);
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'simple-export': SimpleExportService;
  }
}
